require('./keepAlive.tpl.html');
require('./keepAliveController.js');
require('./keepAliveMediator.js');
require('./keepAliveRepository.js');

const KeepAliveComponent = {
    templateUrl: '/keepAlive/keepAlive.tpl.html',
    controller: 'keepAliveController',
    bindings: {}
};

angular.module('umCore')
    .component('keepAlive', KeepAliveComponent);
